var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37.592,
    height: 36.215,
    viewBox: "0 0 37.592 36.215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.023,
    y1: 0.495,
    x2: 1.074,
    y2: 0.502,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#224800"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Combined_Shape_Copy_4d",
    x: 0,
    y: 0,
    width: 37.592,
    height: 36.215,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#009322",
    floodOpacity: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Combined_Shape_Copy_4d)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape_Copy_4d-2",
    "data-name": "Combined Shape Copy 4d",
    d: "M7.681,16.115.32,8.977a1.161,1.161,0,0,1,0-1.6L7.681.237c.571-.553,1.427-.073,1.427.8V15.314a.962.962,0,0,1-.878,1.037A.782.782,0,0,1,7.681,16.115Zm3.237-2.846V2.919h4.369v10.35Zm12.233,0V2.918H27.52v10.35Zm-6.116,0V2.918H21.4v10.35Z",
    transform: "translate(24.08 33.22) rotate(-140)",
    opacity: 0.9,
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownGreen);
export default __webpack_public_path__ + "static/media/arrow_down_green.6aa38fec7646a9ae83d5ed5a7ab7786e.svg";
export { ForwardRef as ReactComponent };